<template>
  <div class="report-branded-header">
    <div class="report-header-inner">
      <!-- Company Logo -->
      <div class="report-header-logo">
        <img
          v-if="logoUrl"
          :src="logoUrl"
          :alt="companyName + ' logo'"
          @error="onLogoError"
        >
        <div v-else class="logo-placeholder">
          {{ companyInitials }}
        </div>
      </div>

      <!-- Report Info -->
      <div class="report-header-info">
        <div class="report-header-company">{{ companyName }}</div>
        <h2 class="report-header-title">{{ title }}</h2>
        <div class="report-header-meta">
          <span v-if="period" class="report-header-meta-item">
            <i class="bx bx-calendar"></i>
            <strong>Period:</strong> {{ period }}
          </span>
          <span v-if="department" class="report-header-meta-item">
            <i class="bx bx-building-house"></i>
            <strong>Dept:</strong> {{ department }}
          </span>
          <span class="report-header-meta-item">
            <i class="bx bx-time-five"></i>
            <strong>Generated:</strong> {{ generatedAt }}
          </span>
        </div>
      </div>

      <!-- Badge -->
      <div class="report-header-badge">
      </div>
    </div>

    <!-- Stats bar (optional) -->
    <template v-if="stats && stats.length > 0">
      <div class="report-header-separator"></div>
      <div class="report-header-stats">
        <span v-for="(stat, idx) in stats" :key="idx" class="report-header-stat">
          <i v-if="stat.icon" :class="stat.icon"></i>
          {{ stat.label }}: <strong>{{ stat.value }}</strong>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { county_logo } from '@/api';
import { getCompanyName } from '@/utils/reportExportUtils';

export default {
  name: 'ReportHeader',
  props: {
    /** Report title – e.g. "Daily Attendance Report" */
    title: {
      type: String,
      required: true
    },
    /** Report date range or period label */
    period: {
      type: String,
      default: ''
    },
    /** Department name */
    department: {
      type: String,
      default: ''
    },
    /** Show CONFIDENTIAL tag */
    confidential: {
      type: Boolean,
      default: true
    },
    /**
     * Optional quick-stat pills displayed below the header.
     * Each item: { icon: 'bx bx-user', label: 'Total', value: 42 }
     */
    stats: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      logoUrl: county_logo || null,
      logoFailed: false
    };
  },
  computed: {
    companyName() {
      return getCompanyName();
    },
    companyInitials() {
      if (!this.companyName) return 'SS';
      return this.companyName
        .split(/\s+/)
        .slice(0, 2)
        .map(w => w.charAt(0))
        .join('')
        .toUpperCase();
    },
    generatedAt() {
      const now = new Date();
      return now.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  methods: {
    onLogoError() {
      this.logoFailed = true;
      this.logoUrl = null;
    }
  }
};
</script>

<style>
@import "@/assets/css/report-header.css";
</style>
